<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 11:52:31
 * @Description: 医生退诊
-->
<template>
  <div class="custom-22" :style="{ backgroundColor: bgColor, color: color }">
    <div class="info-content">
      <div class="left">
        <div class="left-img">
          <img src="../../static/IM/twentytwo-msg.png" alt="" />
        </div>
        <div class="left-content">
          <div class="title">医生已退诊</div>
          <div class="descript">退诊原因：{{ data.refusalReason }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    bgColor: {
      type: String,
      default: '#F5F5F5',
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}
</script>

<style scoped lang="less">
.custom-22 {
  border-radius: 4px;
  width: 350px;
  border-radius: 4px;
  cursor: pointer;
  .info-content {
    padding: 15px 20px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .left-img {
        margin-right: 15px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .left-content {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;

        .title {
          font-size: 12px;
          font-weight: 600;
          color: #333;
        }
        .descript {
          font-size: 11px;
          font-weight: 400;
          color: #666;
        }
      }
    }
  }
}
</style>